<template>
  <!-- Page Wrapper -->
  <div id="wrapper">

    <!-- Content Wrapper -->
    <div id="content-wrapper" class="d-flex flex-column">

      <!-- Main Content -->
      <div id="content">

        <!-- Topbar -->
        <TopNav v-if="!noTopnav" />
        <!-- End of Topbar -->

        <!-- Begin Page Content -->
        <div class="container-fluid vld-parent pt-4">
          <Notification v-bind.sync="appAlertOptions" />

          <Loader
            :loading="isLoadingPage"
            :full-page="false"
          />

          <!-- Page Heading -->
          <PageHeader
            v-if="hasTitle"
            :title="$get($route, 'meta.title', undefined)"
          />

          <router-view></router-view>

          <a
            hidden
            class="d-none"
            id="file_link"
          />
        </div>
        <!-- /.container-fluid -->

      </div>
      <!-- End of Main Content -->

      <!-- Footer -->
      <!-- TODO: fix footer stickiness to bottom -->
      <!-- <FooterComp /> -->
      <!-- End of Footer -->

    </div>
    <!-- End of Content Wrapper -->

  </div>
  <!-- End of Page Wrapper -->
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import TopNav from '@/components/TopNav';
import PageHeader from '@/components/PageHeader';
import Loader from '@/components/Loader';
import Notification from '@/components/Notification';
// import FooterComp from '@/components/FooterComp';

export default {
  name: 'app',
  components: {
    TopNav,
    PageHeader,
    Loader,
    Notification,
    // FooterComp,
  },
  computed: {
    hasTitle() {
      const title = this.$get(this.$route, 'meta.title', undefined);
      return typeof title === 'string' && title.length > 0;
    },
    noTopnav() {
      return this.$get(this.$route, 'meta.noTopnav', false);
    },
    appAlertOptions() {
      return this.globalAlert;
    },
    ...mapState(['globalAlert']),
    ...mapGetters(['isLoadingPage']),
  },
};
</script>

<style lang="scss">
@import './styles/global';
$sidenav-w: 22%;
.sidenav-col {
  width: 22%;
  margin-left: -15px;
}
.content {
  width: 100% - $sidenav-w;
  background-color: #eee;
}
</style>
